<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    chartData: { type: Object },
    options: { type: Object },
  },
  mounted() {
    this.renderAreaChart();
  },
  watch: {
    charDataThisWeek: function(newVal, oldVal) {
      this.renderAreaChart();
    },
    charDataLastWeek: function(newVal, oldVal) {
      this.renderAreaChart();
    },
  },
  computed: {
    chartDataLocal: function() {
      return this.chartData;
    },
    charDataThisWeek: function() {
      return this.chartData["thisWeek"];
    },
    charDataLastWeek: function() {
      return this.chartData["lastWeek"];
    },
  },
  methods: {
    renderAreaChart: function() {
      let lastWeek = this.chartDataLocal["lastWeek"];
      if (!lastWeek) lastWeek = [];
      let lastWeekParticipants = lastWeek.map((item) => item.participants);
      if (lastWeekParticipants && lastWeekParticipants.length > 1) {
        lastWeekParticipants = lastWeekParticipants.flatMap((item) => item[0]);
      }
      const thisWeek = this.chartDataLocal["thisWeek"];
      let thisWeekParticipants = thisWeek.map((item) => item.participants);
      if (thisWeekParticipants && thisWeekParticipants.length > 1) {
        thisWeekParticipants = thisWeekParticipants.flatMap((item) => item[0]);
      }
      this.renderChart(
        {
          labels: thisWeek.map((item) => item.date),
          datasets: [
            {
              label: "Week",
              data: thisWeekParticipants,
              borderColor: "#ffffff",
              borderWidth: 0.5,
              backgroundColor: "#64a0c8",
            },
            {
              label: "Compare",
              data: lastWeekParticipants,
              borderColor: "#ffffff",
              borderWidth: 0.5,
              backgroundColor: "rgba(205, 205, 205, 0.75)",
            },
          ],
        },
        this.options
      );
    },
  },
};
</script>

<style scoped></style>
